export const EMPTY_MV_NOTE_CHECKOUT_CONFIRMATION =
  "No visit note has been added for this ongoing treatment. Continue to checkout without a note?";

export function confirmCheckoutWithoutMvNote(confirmFn) {
  return confirmFn(EMPTY_MV_NOTE_CHECKOUT_CONFIRMATION) === true;
}
